@if (KxRelatedContentObservable && (source === 'kx' || source === 'both')) {
  <content-list
    [content]="KxRelatedContentObservable"
    type="image-slider"
    head="{{ source === 'both' ? 'Similar items from KX' : 'You may also be interested in:' }}"
  ></content-list>
}

@if (
  CfaesRelatedContentObservable && (source == 'cfaes' || source === 'both') && !router.url.includes('profiles')
  ) {
  <content-list
    [content]="CfaesRelatedContentObservable"
    type="text-slider"
    head="Similar items from around the college"
  ></content-list>
}

@if (
  CfaesPeopleObservable && (source == 'cfaes' || source === 'both')
  ) {
  <content-list
    [content]="CfaesPeopleObservable"
    type="text-slider"
    head="People who may be working in this field"
  ></content-list>
}
<br>